import moment from "moment";
import React from "react";
import { formatBirthdateWithAge } from "utilities";

interface Props {
  birthdate: moment.Moment
}

const BirthdateRow = ({ birthdate }: Props) => {
  return <div>
    {formatBirthdateWithAge(birthdate, RESX.Contact.YearsOld)}
  </div>
};

export default BirthdateRow;